// extracted by mini-css-extract-plugin
export default {"assignmentStatusWrapper":"styles_assignmentStatusWrapper__793EP"};